import { render } from "./QyProductDetail.vue?vue&type=template&id=f247bb4c"
import script from "./QyProductDetail.vue?vue&type=script&lang=js"
export * from "./QyProductDetail.vue?vue&type=script&lang=js"

import "./QyProductDetail.vue?vue&type=style&index=0&id=f247bb4c&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__